export default `
  mutation revokeApiKey {
    revokeApiKey
  }
`
